import React, { Children, Component } from "react";
import { node } from "prop-types";
import Grid from "react-bootstrap/lib/Grid";

class ProductToolbar extends Component {
    static propTypes = {
        children: node.isRequired,
    };

    render() {
        const { children } = this.props;

        return (
            <Grid fluid>
                <ul className="d-flex items-center nav nav-pills product-detail-commands">
                    {Children.map(children, (child) => child && <li>{child}</li>)}
                </ul>
            </Grid>
        );
    }
}

export default ProductToolbar;
